import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DemoVideoMessages } from './DemoVideo.messages';

const YOUTUBE_ID = 'eWslhfHrfk4';

export const DemoVideo: React.FC = () => {
  const { t } = useTranslation();
  const [loaded, setLoaded] = useState(false);

  return (
    <section className="demo-video-section">
      <div className="container" style={{ maxWidth: 800, textAlign: 'center' }}>
        <h2 className="demo-video-heading">{t(DemoVideoMessages.TITLE)}</h2>
        <div className="demo-video-wrapper">
          {loaded ? (
            <iframe
              src={`https://www.youtube-nocookie.com/embed/${YOUTUBE_ID}?autoplay=1&rel=0`}
              title="Localingos Demo"
              allow="autoplay; encrypted-media"
              allowFullScreen
            />
          ) : (
            <button className="demo-video-thumb" onClick={() => setLoaded(true)} aria-label={t(DemoVideoMessages.PLAY_ARIA)}>
              <img src={`https://img.youtube.com/vi/${YOUTUBE_ID}/maxresdefault.jpg`} alt="Localingos demo" loading="lazy" />
              <div className="demo-video-play">
                <svg viewBox="0 0 68 48" width="68" height="48"><path d="M66.52 7.74c-.78-2.93-2.49-5.41-5.42-6.19C55.79.13 34 0 34 0S12.21.13 6.9 1.55c-2.93.78-4.63 3.26-5.42 6.19C.06 13.05 0 24 0 24s.06 10.95 1.48 16.26c.78 2.93 2.49 5.41 5.42 6.19C12.21 47.87 34 48 34 48s21.79-.13 27.1-1.55c2.93-.78 4.64-3.26 5.42-6.19C67.94 34.95 68 24 68 24s-.06-10.95-1.48-16.26z" fill="red"/><path d="M45 24L27 14v20" fill="white"/></svg>
              </div>
            </button>
          )}
        </div>
      </div>
    </section>
  );
};
